
export class RetryOptions {
	retries?: number = 5;
	timeout?: number = 1000;
	log?: boolean = false;
}

export class RetryRequest {

	private options: RetryOptions;

	constructor(options?: RetryOptions) {
		if (options) {
			this.options = Object.assign(new RetryOptions(), options);
		}
	}

	/**
	 * Fetch with retry and timeout
	 * 
	 * Help from https://stackoverflow.com/a/66499718 
	 * @param executor 
	 * @param options 
	 * @returns 
	 */
	public async fetch<T>(executor: (signal: AbortSignal) => Promise<T>, options?: RetryOptions): Promise<T> {

		if (!options) {
			options = this.options;
		}

		try {
			const controller: AbortController = new AbortController();
			const timeoutId = setTimeout(() => {
				controller.abort();
			}, options.timeout);

			const response = await executor(controller.signal);

			clearTimeout(timeoutId);
			return response;

		} catch (e) {
			if (options.retries === 1 || options.retries < 1) {
				// Failed
				throw (e);
			}
			// decrement the retries
			return await this.fetch(executor, {
				timeout: options.timeout,
				retries: options.retries - 1
			});
		}
	}
}
